import { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useAsync } from "../../../../utils/hooks/useAsync";
import { AdminService } from "../../utils";
import "./HighlightedMain.scss";

type Props = {
  carousel: CarouselExtended;
};

const HighlightedMain: React.FC<Props> = ({ carousel }) => {
  const { run } = useAsync();
  const [orders, setOrders] = useState<number[]>();
  const [changed, setChanged] = useState<boolean>(false);
  const [displayedCarousel, setDisplayedCarousel] =
    useState<CarouselExtended>(carousel);
  useEffect(() => {
    setOrders(
      carousel.products.map((el) => {
        return el.order;
      })
    );
  }, []);
  const collapsible = (gauge: string) => (
    <div className="trigger">
      <p>{gauge}</p>
    </div>
  );
  const handleChangeOrder = (e: any, productId: string) => {
    let auxEl = displayedCarousel.products.find(
      (el) => el.productId._id == productId
    );
    let aux = displayedCarousel.products.filter(
      (el) => el.productId._id != productId
    );
    auxEl && aux.splice(e.currentTarget.value - 1, 0, auxEl);
    for (let index = 0; index < aux.length; index++) {
      aux[index].order = index + 1;
    }
    setDisplayedCarousel({ ...displayedCarousel, products: aux });
    setChanged(true);
  };

  const handleSaveOrder = () => {
    let updateCarousel = {
      name: displayedCarousel.name,
      products: displayedCarousel.products.map((el) => {
        let res = { order: el.order, productId: el.productId._id };
        return res;
      }),
    };
    run(AdminService.updateCarouselOrder(updateCarousel)).then(() => {
      setChanged(false);
      toast.success("Modificación guardada");
    });
  };

  return (
    <>
      <ToastContainer autoClose={1500} position={"bottom-left"} />
      <Collapsible
        className="highlightedSearchHeather"
        triggerOpenedClassName="highlightedSearchHeather"
        triggerWhenOpen={"∧ " + carousel.label}
        trigger={"∨ " + carousel.label}
      >
        <div className="highlightedSearchItems">
          <p className="highlightedSearchItems_short">ORDEN</p>
          <p
            className="highlightedSearchItems_long"
            style={{ fontFamily: "Mont-Light" }}
          >
            PRODUCTO
          </p>
          <p className="highlightedSearchItems_med">MATERIAL</p>
        </div>
        {displayedCarousel.products.map((el) => {
          return (
            <div className="highlightedSearchItems" key={el.productId._id}>
              <select
                name="order"
                className="highlightedSearchItems_short"
                value={el.order}
                id="order"
                onChange={(e) => handleChangeOrder(e, el.productId._id || "")}
              >
                {orders?.map((el) => {
                  return (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  );
                })}
              </select>
              <Link
                className="highlightedSearchItems_long"
                to={"/admin/edit/" + el.productId.friendlyUrl}
              >
                <p className="highlightedSearchItems_long">
                  {el.productId.title}
                </p>
              </Link>
              <p className="highlightedSearchItems_med">
                {el.productId.material == "silver" ? "Plata" : "Oro"}
              </p>
            </div>
          );
        })}
      </Collapsible>
      {changed && (
        <button
          type="button"
          className="saveNewOrderButton"
          onClick={handleSaveOrder}
        >
          Guardar orden
        </button>
      )}
    </>
  );
};

export default HighlightedMain;
